window.coma = window.coma || {};

window.coma.tabs = (function ($, undefined) {

	// PRIVATE FUNCTIONS
	var _private = {
		// these are all possible color classes in one string (used within removeClass)
		allColorClasses: 'ci gas oil electricity technology environment',

		init: function () {

			// initially set height and add events
			var $tabs = $('.tabs');

			$.each($tabs, function (i, _tabs) {
				var _$tabs = $(_tabs);

				// add .active to first-child (li), if there is no active child
				if (_$tabs.find('li.active').length === 0) {
					_$tabs.find('li:first-child').addClass('active');
				}

				_private.addClickEvents(_tabs);
			});

			// init phone number once
			_private.setContactTeaser();

			// // listen to mediaqueries-changed
			$(document).on('mediaqueries-changed', function () {
				setTimeout(_private.setAllActiveHeights, 200);
			});

			// // listen to tabs-changed
			$(document).on('tabs-changed', function () {
				_private.setContactTeaser();
				_private.setAllActiveHeights();
			});

			// trigger click() on active links once (due to initial height calc bug)
			// NOTE: it seemed fine without...
			// $('.tabs li.active > a').click();

			// do initial height calc
			setTimeout(_private.setAllActiveHeights, 500);
		},

		setContactTabPhoneNumber: function () {
			var $tabs = $('.tabs'),
				$contactTab = $tabs.find('li.contact');

			if ($contactTab.length === 1) {
				var $phoneNumber = $contactTab.find('section:eq(0) h6').next('strong');

				try {
					if (typeof _private.phoneJSON === 'undefined')
						_private.phoneJSON = $.parseJSON($phoneNumber.text());
					if ($tabs.find('li.gas').hasClass('active'))
						$phoneNumber.html(_private.phoneJSON.gas);
					else if ($tabs.find('li.oil').hasClass('active'))
						$phoneNumber.html(_private.phoneJSON.oil);
					else if ($tabs.find('li.electricity').hasClass('active'))
						$phoneNumber.html(_private.phoneJSON.electricity);
				}
				catch (err) {
					// do nothing
				}
			}
		},

		setContactTeaser: function () {
			var $tabs = $('.tabs'),
				$contactTab = $tabs.find('li.contact');

			if ($contactTab.length === 1) {
				try {
					if ($tabs.find('li.gas').hasClass('active')) {
						if ($contactTab.find('section').length > 1) {
							$contactTab.find('section').hide();
							if ($contactTab.find('section.gas').length > 0)
								$contactTab.find('section.gas').show();
							else
								$contactTab.find('section:eq(0)').show();
						}
					}
					else if ($tabs.find('li.oil').hasClass('active')) {
						if ($contactTab.find('section').length > 1) {
							$contactTab.find('section').hide();
							if ($contactTab.find('section.oil').length > 0)
								$contactTab.find('section.oil').show();
							else
								$contactTab.find('section:eq(0)').show();
						}
					}
					else if ($tabs.find('li.electricity').hasClass('active')) {
						if ($contactTab.find('section').length > 1) {
							$contactTab.find('section').hide();
							if ($contactTab.find('section.electricity').length > 0)
								$contactTab.find('section.electricity').show();
							else
								$contactTab.find('section:eq(0)').show();
						}
					}
					_private.setContactTabPhoneNumber();
				}
				catch (err) {
					// do nothing
					//console.log(err);
				}
			}
		},

		setAllActiveHeights: function () {
			var $tabs = $('.tabs');

			$.each($tabs, function (i, tabs) {
				_private.setActiveHeight(tabs);
			});

			_private.setSameHeight();
		},

		// calc the necessary height for the tabs containers
		// (tab content is absolutely positioned)
		setActiveHeight: function (tabs) {
			var $tabs = $(tabs);

			// wait 200 ms for any class changes to take effect in layout
			 setTimeout(function () {
				if ($tabs.find('section').css('position') === 'absolute') {
					// tabs contain a absolute positioned section
					var $section = $tabs.find('li.active section');
					var height = parseInt($section.css('height'));
					var marginTop = parseInt($section.css('marginTop'));
					var borderTop = parseInt($section.css('borderTopWidth'));
					var paddingTop = parseInt($section.css('paddingTop'));
					var paddingBottom = parseInt($section.css('paddingBottom'));

					$tabs.css('height', height + marginTop + borderTop + paddingTop + paddingBottom + 'px');
				}
				else {
					// else (accordion) has height:auto;
					$tabs.css('height', 'auto');
				}
			 }, 200);
		},

		// make the calculator and the contact tabs the same height
		setSameHeight: function () {
			var $contactTabs = $('.tabs').find('> .contact').closest('.tabs'),
				$contactSections = $contactTabs.find('section'),
				$calculatorTabs = $('.tariff-calculator').closest('.tabs'),
				$calculatorSections = $calculatorTabs.find('section'),
				$calculatorSteps = $calculatorSections.find('.step-1, .step-2, .step-3');

			// wait 200 ms for any class changes to take effect in layout
			setTimeout(function () {
				if (window.coma.mediaqueries.getDevice() === 'lg') {
					if ($('.tariff-calculator').length) {
						var contactHeight = $contactSections.height(),
							calculatorHeight = $calculatorSections.height();

						// reset
						$calculatorSections.css('min-height', '');
						$calculatorSteps.css('min-height', '');

						if (calculatorHeight > contactHeight) {
							$contactSections.css('min-height', calculatorHeight);
							$calculatorSections.css('min-height', calculatorHeight);
							$calculatorSteps.css('min-height', calculatorHeight - parseInt($calculatorSteps.css('margin-top')) - parseInt($calculatorSteps.css('margin-bottom')));
						}
						else {
							$calculatorSections.css('min-height', contactHeight);
							$calculatorSteps.css('min-height', contactHeight - parseInt($calculatorSteps.css('margin-top')) - parseInt($calculatorSteps.css('margin-bottom')));
						}
					}
				} else {
					$contactSections.css('min-height', '');
					$calculatorSections.css('min-height', '');
					$calculatorSteps.css('min-height', '');
				}
			}, 200);
		},

		addClickEvents: function (tabs) {
			var $elm = $(tabs);
			$elm.find('> li > a').on('click', function (e) {
				e.preventDefault();

				var $self = $(this);

				$self.closest('ul').find('.active').removeClass('active');
				$self.closest('li').addClass('active');

				$(document).trigger({
					type: 'tabs-changed'
				});
			});
		}
	};

	// CALL INIT
	$(document).ready(function () {
		_private.init();
	});

	// PUBLIC FUNCTIONS
	return {
		setAllActiveHeights: _private.setAllActiveHeights
	}

}(jQuery));